const initializeRyuDrawer = () => {
  const drawer = document.querySelector('#RyuNavigationDrawer');
  const openButton = document.querySelector('[data-ryu-drawer-open]');
  const closeButtons = document.querySelectorAll('[data-ryu-drawer-close]');
  if (!drawer || !openButton || drawer.dataset.ryuDrawerReady) return;

  drawer.dataset.ryuDrawerReady = 'true';
  let returnFocus = openButton;
  let resizeFrame;

  const updateDrawerOffset = () => {
    const announcement = document.querySelector('.announcement-bar');
    const announcementRect = announcement?.getBoundingClientRect();
    const offset = announcementRect && announcementRect.top <= 0 && announcementRect.bottom > 0
      ? announcementRect.bottom
      : 0;
    drawer.style.setProperty('--ryu-drawer-offset', `${Math.max(0, offset)}px`);
  };

  const closeDrawer = () => {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    openButton.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('ryu-drawer-open');
    window.setTimeout(() => returnFocus?.focus(), 180);
  };

  const openDrawer = () => {
    returnFocus = document.activeElement;
    updateDrawerOffset();
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    openButton.setAttribute('aria-expanded', 'true');
    document.body.classList.add('ryu-drawer-open');
    window.setTimeout(() => drawer.querySelector('[data-ryu-drawer-close]')?.focus(), 80);
  };

  openButton.addEventListener('click', openDrawer);
  closeButtons.forEach((button) => button.addEventListener('click', closeDrawer));
  drawer.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeDrawer));
  window.addEventListener('resize', () => {
    if (resizeFrame) return;
    resizeFrame = window.requestAnimationFrame(() => {
      resizeFrame = undefined;
      updateDrawerOffset();
    });
  }, { passive: true });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });
};

document.addEventListener('DOMContentLoaded', initializeRyuDrawer);
document.addEventListener('shopify:section:load', initializeRyuDrawer);
